import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { CONTACT } from "@/lib/i18n";

const MESSAGES = {
  pt: "Olá BID Soluções Integradas, gostaria de agendar uma consultoria técnica.",
  en: "Hello BID, I would like to schedule a technical consultation.",
  fr: "Bonjour BID, j'aimerais planifier une consultation technique.",
};

const LABELS = {
  pt: "Fale conosco no WhatsApp",
  en: "Chat with us on WhatsApp",
  fr: "Parlez-nous sur WhatsApp",
};

const FloatingWhatsApp = ({ t, lang = "pt" }) => {
  const [showLabel, setShowLabel] = useState(false);
  const [hidden, setHidden] = useState(false);

  // Auto-show label after 4 seconds to attract attention
  useEffect(() => {
    const timer = setTimeout(() => setShowLabel(true), 4000);
    const hideTimer = setTimeout(() => setShowLabel(false), 11000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (hidden) return null;

  const message = encodeURIComponent(MESSAGES[lang] || MESSAGES.pt);
  const href = `https://wa.me/${CONTACT.whatsappRaw}?text=${message}`;
  const label = LABELS[lang] || LABELS.pt;

  return (
    <div
      className="fixed bottom-20 right-6 z-40 flex items-end gap-3"
      data-testid="floating-whatsapp-wrapper"
    >
      {/* Label / tooltip */}
      {showLabel && (
        <div
          className="hidden sm:flex items-center gap-2 bg-white border border-[#0a192f]/10 shadow-2xl px-4 py-3 pr-10 relative animate-in fade-in slide-in-from-right-3 duration-500"
          style={{ borderRadius: "4px" }}
        >
          <div>
            <div className="bid-overline text-[10px] text-[#d4af37]">BID</div>
            <p className="text-xs font-display font-bold text-[#0a192f] leading-tight">
              {label}
            </p>
            <p className="text-[10px] text-[#4a5568] mt-0.5">
              {CONTACT.whatsappDisplay}
            </p>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowLabel(false);
            }}
            className="absolute top-1 right-1 text-[#0a192f]/40 hover:text-[#0a192f]"
            aria-label="close"
          >
            <X className="w-3 h-3" />
          </button>
          {/* Arrow */}
          <div
            className="absolute -right-2 bottom-5 w-0 h-0"
            style={{
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              borderLeft: "8px solid white",
            }}
          />
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label={label}
        onClick={() => setShowLabel(false)}
        className="relative bg-[#25D366] hover:bg-[#1EBE5D] text-white w-14 h-14 sm:w-16 sm:h-16 rounded-full shadow-2xl flex items-center justify-center transition-transform hover:scale-110 group"
        style={{ boxShadow: "0 10px 30px rgba(37,211,102,0.4)" }}
      >
        <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" strokeWidth={2} />
        {/* Pulse */}
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#d4af37] rounded-full animate-ping" />
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#d4af37] rounded-full" />
        {/* Hover tooltip */}
        <span className="sr-only">{label}</span>
      </a>
    </div>
  );
};

export default FloatingWhatsApp;
